var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { layout } from '@joint/layout-elk';
import { Attribute, LAYOUT_BATCH_NAME } from '../../const';
export function layoutCells(graph, cells, options) {
    return __awaiter(this, void 0, void 0, function* () {
        const { nodes, edges, } = cells;
        try {
            graph.startBatch(LAYOUT_BATCH_NAME);
            // Lay out the given cells only (e.g. not the notes), in the order ELK should consider
            yield layout([...nodes, ...edges], {
                elkLayoutOptions: getElkLayoutOptions(options),
                exportElement: ({ element, elkNode }) => {
                    var _a;
                    const node = element;
                    const partitionIndex = (_a = node.get(Attribute.PartitionIndex)) !== null && _a !== void 0 ? _a : 1000;
                    elkNode.layoutOptions['elk.partitioning.partition'] = partitionIndex;
                    if (node.get('type') === 'trigger') {
                        elkNode.layoutOptions['elk.layered.layering.layerChoiceConstraint'] = 0;
                    }
                    elkNode.labels = node.getLabelsRelativeRects().map(rect => ({
                        width: rect.width,
                        height: rect.height,
                        x: rect.x,
                        y: rect.y,
                        layoutOptions: {}
                    }));
                }
            });
        }
        catch (error) {
            console.warn('ELK layout error:', error);
        }
        finally {
            graph.stopBatch(LAYOUT_BATCH_NAME);
        }
    });
}
function getElkLayoutOptions(options) {
    const layoutOptions = {
        'elk.algorithm': 'layered',
        'elk.direction': 'RIGHT',
        'elk.separateConnectedComponents': false,
        'elk.edgeRouting': 'ORTHOGONAL',
        'elk.partitioning.activate': true,
        'elk.layered.spacing.nodeNodeBetweenLayers': 100,
        'elk.spacing.edgeNode': 50,
        'elk.layered.spacing.edgeNodeBetweenLayers': 50,
        'elk.layered.feedbackEdges': true,
        // Preserve model order
        'elk.layered.considerModelOrder.strategy': 'PREFER_EDGES',
        'elk.layered.cycleBreaking.strategy': 'DFS_NODE_ORDER',
        // Don't reorder nodes within a layer during crossing minimization
        'elk.layered.crossingMinimization.forceNodeModelOrder': true,
        // Center layers as a whole (optional)
        'elk.layered.nodePlacement.bk.fixedAlignment': 'BALANCED'
    };
    if (options === null || options === void 0 ? void 0 : options.disableOptimalOrderHeuristic) {
        Object.assign(layoutOptions, {
            'elk.layered.crossingMinimization.strategy': 'NONE', // No crossing minimization is done (at all)
            'elk.layered.crossingMinimization.greedySwitch.type': 'OFF', // Disables greedy switch
        });
    }
    return layoutOptions;
}
